function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { messageListApi, messageStatusApi, messageSubscribeApi, messageSyncApi, messageCateApi } from '@/api/setting';
export default {
  name: 'Apply',
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    formBox: function formBox() {
      return import('./components/formBox');
    },
    messageTimes: function messageTimes() {
      return import('./components/messageTimes');
    }
  },
  data: function data() {
    return {
      tableData: [],
      messageData: {},
      where: {
        page: 1,
        limit: 15,
        cate_id: '',
        title: ''
      },
      total: 0,
      loadBtn: false,
      loading: false,
      type: [0, 1],
      searchData: [{
        field_name: '标题/内容',
        field_name_en: 'title',
        form_value: 'input'
      }, {
        field_name: '消息类型',
        field_name_en: 'cate_id',
        form_value: 'cascader_radio',
        data_dict: []
      }]
    };
  },
  created: function created() {
    this.where.limit = Math.floor((window.innerHeight - 320) / 56);
  },
  mounted: function mounted() {
    this.getMessageCate();
    this.getTableData();
  },
  methods: {
    // 获取列表
    getTableData: function getTableData() {
      var _this = this;
      messageListApi(this.where).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.count;
        if (_this.tableData && _this.tableData.length > 0) {
          _this.tableData.forEach(function (value) {
            value.message_template.sort(function (a, b) {
              return a.type - b.type;
            }); //升序
          });
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where.title = '';
        this.where.cate_id = '';
      } else {
        if (data.cate_id && Array.isArray(data.cate_id)) {
          data.cate_id = data.cate_id[data.cate_id.length - 1];
        }
        this.where = _objectSpread(_objectSpread({}, this.where), data);
      }
      this.where.page = 1;
      this.getTableData();
    },
    getMessageSync: function getMessageSync() {
      var _this2 = this;
      this.loadBtn = true;
      messageSyncApi().then(function (res) {
        _this2.loadBtn = false;
        _this2.where.page = 1;
        _this2.getTableData();
      }).catch(function (error) {
        _this2.loadBtn = false;
      });
    },
    handleTime: function handleTime(row) {
      var type = '';
      if (row.template_type == 'clock_remind' || row.template_type == 'clock_remind_after_work' || row.template_type == 'remind_work_card_short') {
        type = 1;
      }
      this.messageData = {
        width: '560px',
        title: '设置提醒时间',
        type: type,
        data: row
      };
      this.$refs.messageTimes.handleOpen();
    },
    //修改状态
    messageStatus: function messageStatus(row, type) {
      var _this3 = this;
      messageStatusApi(row.id, type, {
        status: row.message_template[type].status
      }).then(function (res) {
        _this3.getTableData();
      }).catch(function (error) {
        row.message_template[type].status = !row.message_template[type].status;
      });
    },
    //修改状态
    messageSubscribe: function messageSubscribe(row) {
      var _this4 = this;
      messageSubscribeApi(row.id, {
        status: row.user_sub
      }).then(function (res) {
        _this4.getTableData();
      }).catch(function (error) {
        row.row.user_sub = !row.user_sub;
      });
    },
    getMessageCate: function getMessageCate() {
      var _this5 = this;
      messageCateApi().then(function (res) {
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].name = res.data[i].label;
        }
        _this5.searchData[1].data_dict = res.data;
      });
    }
  }
};